import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialStats = ({ platforms }) => {
  const getPlatformIcon = (platform) => {
    const icons = {
      instagram: 'Instagram',
      youtube: 'Youtube',
      tiktok: 'Music',
      twitter: 'Twitter',
      spotify: 'Music'
    };
    return icons?.[platform] || 'Globe';
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000)?.toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000)?.toFixed(1) + 'K';
    }
    return num?.toString();
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">Sosyal Medya İstatistikleri</h2>
      <div className="space-y-4">
        {platforms?.map((platform, index) => (
          <div key={index} className="flex items-center justify-between p-4 bg-muted rounded-lg">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name={getPlatformIcon(platform?.name)} size={20} color="var(--color-primary)" />
              </div>
              <div>
                <p className="font-medium text-foreground capitalize">{platform?.name}</p>
                <p className="text-sm text-muted-foreground">@{platform?.handle}</p>
              </div>
            </div>
            
            <div className="text-right">
              <p className="text-xl font-bold text-foreground">{formatNumber(platform?.followers)}</p>
              <p className="text-sm text-muted-foreground">Takipçi</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-primary/5 rounded-lg border border-primary/20">
        <div className="flex items-center gap-2 mb-2">
          <Icon name="CheckCircle" size={16} color="var(--color-primary)" />
          <span className="text-sm font-medium text-primary">Doğrulanmış Hesaplar</span>
        </div>
        <p className="text-sm text-muted-foreground">
          Tüm sosyal medya hesapları platform tarafından doğrulanmıştır
        </p>
      </div>
    </div>
  );
};

export default SocialStats;